module.exports = __webpack_public_path__ + "img/271.79c02096.png";